let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("egSUp")).then(() => parcelRequire('7vli6'));